import React from 'react';

class PanelErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details
    console.error('🚨 [PANEL ERROR BOUNDARY] Caught DOM insertion error:', error);
    console.error('🚨 [PANEL ERROR BOUNDARY] Error info:', errorInfo);
    
    // Check if it's the specific DOM insertion error we're trying to catch
    const isDOMInsertionError = error.message && error.message.includes('insertBefore');
    
    if (isDOMInsertionError) {
      console.log('🛡️ [PANEL ERROR BOUNDARY] Detected DOM insertion race condition - attempting recovery');
      
      // Store error details
      this.setState({
        error,
        errorInfo,
        isDOMInsertionError: true
      });
      
      // Attempt recovery after a short delay
      setTimeout(() => {
        console.log('🔄 [PANEL ERROR BOUNDARY] Attempting recovery from DOM race condition');
        this.setState({ hasError: false, error: null, errorInfo: null });
      }, 100);
    } else {
      // Store error details for other errors
      this.setState({
        error,
        errorInfo,
        isDOMInsertionError: false
      });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.isDOMInsertionError) {
        // For DOM insertion errors, show a minimal loading state during recovery
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'var(--color-text-secondary, #666)',
            fontSize: '14px'
          }}>
            <div>Stabilizing layout...</div>
          </div>
        );
      } else {
        // For other errors, show a more detailed error state
        return (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px',
            color: 'var(--color-text-secondary, #666)',
            fontSize: '14px'
          }}>
            <div style={{ marginBottom: '10px' }}>
              Something went wrong with the panel layout.
            </div>
            <button 
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              style={{
                padding: '8px 16px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                background: 'white',
                cursor: 'pointer'
              }}
            >
              Try Again
            </button>
          </div>
        );
      }
    }

    return this.props.children;
  }
}

export default PanelErrorBoundary;
